import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import NewApplication from './NewApplication';
import AppApproval from './AppApproval';
import Loader from '../Loader';
import { ApplicationService } from './../../service/application.service';

import '../../../node_modules/reactjs-popup/dist/index.css';

const Application = () => {
    const applicationService = new ApplicationService();

    const [applications, setApplications] = useState([]);
    const [dbapplications, setDBapplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageLoading, setPageLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (loading) {
                    setPageLoading(true);
                    const result = await applicationService.getApplications();
                    setApplications(result.data);
                    setDBapplications(result.data);
                    setLoading(false);

                    setPageLoading(false);
                }
            } catch (error) {
                console.error(error);
                setPageLoading(false);
            }
        };

        fetchData();
    }, [loading]);

    const search = (appName) => {
        if (appName !== undefined) {
            let data = dbapplications;
            let result = data;

            if (appName.trim() !== "") {
                result = data.filter((x) => {
                    return x.name.toLowerCase().indexOf(appName.toLowerCase()) >= 0;
                });
            }
            setApplications(result);
        }
    }

    const reloding = () => {
        setLoading(true);
    }

    const renderApplicationTable = () => {
        return (<table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
                <tr style={{ backgroundColor: "lightgray" }}>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Label</th>
                    <th>BrandLookup</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {applications.map(a =>
                    <tr key={a.id}>
                        <td>{a.id}</td>
                        <td>{a.name}</td>
                        <td>{a.label}</td>
                        <td>{a.brandLookUp}</td>
                        <td>
                            <Popup trigger={<button style={{ width: "30px", border: "1px solid gray" }}><i className="fa fa-edit" aria-hidden="true" title="Application update"></i></button>} nested modal>{close => (<NewApplication id={a.id} callBack={reloding} onClose={() => { close(); }}></NewApplication>)}</Popup>
                        </td>
                        <td>
                            <Popup trigger={<button style={{ width: "30px", border: "1px solid gray" }}><i className="fa fa-user" aria-hidden="true" title="Set application approver"></i></button>} nested modal>{close => (<AppApproval id={a.id} callBack={reloding} showCloseButton="true" onClose={() => { close(); }}></AppApproval>)}</Popup>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>);
    }

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderApplicationTable(applications);

    return (
        <>
            {pageLoading && <Loader />}
            <div className="card">
                <h5 className="card-header py-3"><i className="fa fa-folder-open-o" aria-hidden="true"></i> Applications</h5>
                <div className="card-body" style={{ height: "75vh" }}>
                    <div style={{ marginTop: "-10px" }}>
                        <Popup trigger={<button className="btn btn-light" style={{ border: "1px solid lightgray" }}><i className="fa fa-plus"></i>  Add new application</button>} nested modal>{close => (<NewApplication id={0} callBack={reloding} onClose={() => { close(); }}></NewApplication>)}</Popup>
                        <div className="form-group has-search" style={{ float: "right" }}>
                            <span className="fa fa-search form-control-feedback"></span>
                            <input onChange={(e) => { search(e.target.value) }} type="text" className="form-control" placeholder="Search application" />
                        </div>
                        <div style={{ clear: "both" }}></div>
                    </div>
                    <hr style={{ marginTop: "-8px" }} />
                    <div style={{ height: "90%", overflowY: "auto", paddingRight: "2px", marginTop: "-5px" }}>
                        {contents}
                    </div>
                </div>
            </div>

        </>
    );
}

export default Application;